document.addEventListener("DOMContentLoaded", () => {
  const LIMIT = 9
  try {
    const key = "recentlyViewedHandles"
    const handle = window.recentlyViewedHandle
    if (!handle) return

    const viewed = [handle, ...(JSON.parse(localStorage.getItem(key)) || [])]
      .filter((h, i, arr) => arr.indexOf(h) === i)
      .slice(0, LIMIT)

    localStorage.setItem(key, JSON.stringify(viewed))
  } catch (e) {
    console.warn("recently-viewed-save error", e)
  }
})
